export { default } from './AspectRatioPaddingBox';
